module.exports = __webpack_public_path__ + "KlarnaLogoFull.3c29c874c61fa71fe5cb94dc9e0e1714.svg";